var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"appContainer",attrs:{"id":"app-container"}},[_c('div',{style:(_vm.appStyle),attrs:{"id":"app"}},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }